/**
 * 用户行为打点
 * @api http://api.umucdn.cn/project/603/interface/api/8630
 * @doc https://docs.google.com/spreadsheets/d/1qUD7k3Dl3FuU_cswVMeaYwIC1efNul1nAIbUswa-1yA/edit#gid=1469618169
 */

import API from './api';
import { fetchData } from './fetch';

export interface IInput {
    page_type: number;
    action_type: number;
}

export const guideLog = (data: IInput) => {
    return fetchData(API.STAT_LOG.url, API.STAT_LOG.type, data);
};
